<template>
  <div class="login-section">
    <LoginForm
      :login-btn-disabled="btnDisabled"
      class="col-12 col-md-10 col-lg-8 col-xl-6 pb-lg-4"
      :validate-value="validateValue"
      @validateValue="validateValue=$event"
      @sendLogin="existCode"
    />
    <AlertaMsj :alerta-msj="alertaMsj" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import AlertaMsj from '@/components/AlertaMsj.vue';
import LoginForm from '../components/Login.vue';
import {validateIdentification} from '@/utils/validations.js';
import {onLogin} from '@/vue-apollo';
import admisionLoginGql from '@/graphql/admisionLogin.gql';
import emailConfirmationGql from '@/graphql/emailConfirmation.gql';
export default {
  name: 'Login',
  components: {
    LoginForm,
    AlertaMsj,
  },
  data() {
    return {
      btnDisabled: false,
      alertaMsj: {
        content: '',
      },
      validateValue: {
        identification: '',
        identificationType: '',
        password: '',
      },
    };
  },
  methods: {
    existCode(login) {
      if (this.$route.params.code) {
        this.emailConfirmation(login);
      } else {
        this.admisionLogin(login);
      }
    },
    emailConfirmation(login) {
      this.btnDisabled = true;
      this.$apollo.mutate({
        mutation: gql`${emailConfirmationGql}`,
        variables: {
          identification: login.identification,
          identificationType: login.identificationType.value,
          code: this.$route.params.code,
        },
      }).then((res) => {
        const msg = res.data.emailConfirmation.msg;
        if (msg == 'email_validated') {
          this.admisionLogin(login);
        }
        if (msg == 'mismatch') {
          this.alertaMsj = {
            content: 'No existe esa combinación de credenciales',
            type: 'danger',
          };
        }
        this.btnDisabled = false;
      }).catch((error) => {
        this.alertaMsj = {
          content: 'Hubo un error procesando su solicitud. Intente de nuevo',
          type: 'danger',
        };
        this.btnDisabled = false;
      });
    },
    admisionLogin(login) {
      if (!login.identificationType.value || !login.identification ||
        !login.password) {
        this.validateValue = {
          identification: 'invalid',
          identificationType: 'invalid',
          password: 'invalid',
        };
        return this.alertaMsj = {
          content: 'Llene todos los datos para iniciar sesión',
          type: 'warning',
        };
      }
      if (!validateIdentification(login.identificationType,
          login.identification) || !login.identificationType.value) {
        this.validateValue = {
          identification: 'invalid',
        };
        return this.alertaMsj = {
          content: login.identificationType.mensaje,
          type: 'warning',
        };
      }
      this.validateValue = {
        identification: 'valid',
        identificationType: 'valid',
        password: 'valid',
      };
      this.btnDisabled = true;
      this.$apollo.mutate({
        mutation: gql`${admisionLoginGql}`,
        variables: {
          identification: login.identification,
          identificationType: login.identificationType.value,
          password: login.password,
        },
      }).then((res) => {
        const msg = res.data.admisionLogin.msg;
        const token = res.data.admisionLogin.token;
        if (msg) {
          switch (msg) {
            case 'user_not_found':
              this.alertaMsj = {
                content: 'Usuario no encontrado',
                type: 'danger',
              };
              break;
            case 'email_confirmation_required':
              this.alertaMsj = {
                content: 'Por favor confirma tu correo'+
                  ' electrónico haciendo clic en el email recibido y luego'+
                  ' reintenta iniciar sesión.',
                type: 'warning',
              };
              break;
            case 'invalid_password':
              this.validateValue = {
                password: 'invalid',
              };
              this.alertaMsj = {
                content: 'Contraseña Inválida',
                type: 'danger',
              };
              break;
            default:
              this.alertaMsj = {
                content: 'Hubo algún error. Intenta más tarde.',
                type: 'danger',
              };
          }
        } else { // Si todo está bien se hace el login y redirect:
          onLogin(this.$apolloProvider.clients.defaultClient, token);
          this.$router.push('/');
        }
        this.btnDisabled = false;
      }).catch((error) => {
        this.alertaMsj = {
          content: 'Hubo un error procesando su solicitud. Intente de nuevo',
          type: 'danger',
        };
        this.btnDisabled = false;
      });
    },
  },
};
</script>
<style lang="scss">
  .login-section {
    align-items: center;
    background-color: $primary-color-dark;
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 56px);
  }
</style>
